import { type ReactNode } from 'react';
import type { Creator } from '@/types';

function VoidBadge(): ReactNode {
  return (
    <span className="inline-flex items-center rounded-sm bg-error/10 px-1.5 py-0.5 text-[10px] font-medium uppercase text-error">
      Anulado
    </span>
  );
}

function TrashBadge(): ReactNode {
  return (
    <span className="inline-flex items-center rounded-sm bg-white/[0.08] px-1.5 py-0.5 text-[10px] font-medium uppercase text-text-secondary">
      Papelera
    </span>
  );
}

// Shown to the admin for leads that the collector discarded via
// user_deleted_at. The collector doesn't see these (filtered out in
// buildBaseFilter); the admin does, with this badge to understand the
// final state. Distinct from TrashBadge (admin-side delete).
function UserDeletedBadge(): ReactNode {
  return (
    <span
      className="inline-flex items-center rounded-sm bg-white/[0.06] px-1.5 py-0.5 text-[10px] font-medium uppercase text-text-tertiary"
      title="Descartado por el creador"
    >
      Descartado
    </span>
  );
}

export function StateBadge({ creator }: { creator: Creator }): ReactNode {
  if (creator.deleted_at) return <TrashBadge />;
  if (creator.is_void) return <VoidBadge />;
  if (creator.user_deleted_at) return <UserDeletedBadge />;
  return null;
}
